import {
  Box,
  Chevron,
  Div,
  H5,
  Icon,
  P,
  VDriveLogo,
  dateFormat,
  lightTheme,
} from '@vgrubs/components';
import { LocationVDriveEntity } from 'components/src/types/location.types';
import { Link } from 'react-router-dom';

export const VDriveComponent = ({
  vDriveVerification,
}: {
  vDriveVerification: LocationVDriveEntity;
}) => {
  return (
    <Link to={`/verifications/v-drive/${vDriveVerification.location.id}`}>
      <Box $flex $between $alignCenter $mb="8">
        <Div $flex $gap="20px" $gapSM="12px" $alignCenter>
          <Div $flex $flexNone $desktop>
            <VDriveLogo width="70" height="70" />
          </Div>
          <Div $flex $flexNone $mobile>
            <VDriveLogo width="50" height="50" />
          </Div>
          <Div>
            <H5 $mb="4">{vDriveVerification.location.name}</H5>
            <P $mb="4">{vDriveVerification.location.address}</P>
            <Div $desktop>
              <P $m="0">
                <span>
                  Owner: {vDriveVerification.owner.firstName}{' '}
                  {vDriveVerification.owner.lastName}
                </span>{' '}
                <span style={{ color: lightTheme.lightGray }}>
                  | Date Created: {dateFormat(vDriveVerification.createdAt)}.
                </span>
              </P>
            </Div>
            <Div $mobile>
              <P $m="0">
                <span>
                  Owner: {vDriveVerification.owner.firstName}{' '}
                  {vDriveVerification.owner.lastName}
                </span>{' '}
                <br />
                <span style={{ color: lightTheme.lightGray }}>
                  Date Created: {dateFormat(vDriveVerification.createdAt)}.
                </span>
              </P>
            </Div>
          </Div>
        </Div>
        <Icon $rotate="90deg">
          <Chevron />
        </Icon>
      </Box>
    </Link>
  );
};
